
import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
@Component({
  name: 'TableEl',
  components: {},
})
export default class TableEl extends Vue {
  @Prop({type: Boolean}) loading!: any;
  @Prop({type: Array}) tableData!: any;
  click(row: any,column: any,e: any) {
    this.$emit("handleClick", row);
  }
}
